import { useNavigate } from 'react-router-dom';
import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './XeroV2.css';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const XeroV2 = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const auth = async () => {
            const searchParams = new URLSearchParams(window.location.search);
            let query = '';
            if (searchParams.get('code')) {
                query =
                    window.location.search.startsWith('?')
                        ? window.location.search
                        : `?${window.location.search}`;
            } else {
                const idx = window.location.href.indexOf('url=');
                const tail =
                    idx >= 0 ? window.location.href.slice(idx + 'url='.length) : '';
                if (!tail || !/\bcode=/i.test(tail)) {
                    toast.error('Missing OAuth code in redirect URL.');
                    navigate('/admin');
                    return;
                }
                query = tail.startsWith('?') ? tail : `?${tail}`;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API}/api/getTokenSet${query}`);
                let body = null;
                try {
                    body = await response.json();
                } catch {
                    body = null;
                }

                if (!response.ok || (body && body.error)) {
                    toast.error(body?.error || `Xero callback failed (${response.status})`);
                    navigate('/admin');
                    return;
                }

                toast.success('Successfully authenticated with Xero');
                navigate('/admin');
            } catch (e) {
                toast.error('Could not finish Xero sign-in.');
                navigate('/admin');
            }
        };

        void auth();
    }, [navigate]);

    return (
        <div className="v2-page order-detail xerov2 mb-50">
            <NavbarV2 />
        </div>
    );
};

export default XeroV2;
